// extracted by mini-css-extract-plugin
module.exports = {"vip-tag":"style_vip-tag__rcqhA","vip-tag__icon":"style_vip-tag__icon__KH4K1"};